import { useEffect, useState } from 'react';
import { Box, Container, Grid, Modal } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import CloseIcon from '@mui/icons-material/Close';
import { Controller, FieldErrors, FieldValues, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import CustomButton from '../../../components/Button/button';
import CustomTextField from '../../../components/TextField/textField';
import CustomTypography from '../../../components/Typography/typography';
import styles from '../../../assets/styles/resetPassword';
import { resetpasswordbyadmin } from '../../../redux/slice/adminSlice';
import ShowPassword from '../../../components/showPassword/ShowPassword';

const ResetPassword = (props: any) => {
  const { open, handlePopUp, user } = props;
  const classes = styles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const resetpasswordData = useSelector(
    (state: any) => state.admin.resetpasswordbyAdminData
  );
  const form = useForm({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  });

  const { formState, handleSubmit, control, clearErrors, reset } = form;
  const { errors } = formState;

  //submit method that calls reset password by admin api
  const onSubmit = (data: FieldValues) => {
    const newData = { ...data, id: user._id };
    dispatch(resetpasswordbyadmin({ newData, navigate }));
  };

  const onError = (errors: FieldErrors) => {};

  useEffect(() => {
    resetpasswordData?._id && handlePopUp();
    resetpasswordData?._id && reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetpasswordData]);

  return (
    <Container maxWidth='xs'>
      <Modal
        open={open}
        onClose={handlePopUp}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <>
          <Box className={classes.boxClass}>
            <CustomTypography
              id='modal-modal-title'
              align='center'
              variant='h5'
              component='div'
            >
              <LockResetIcon fontSize='large' color='primary' />
            </CustomTypography>
            <CustomTypography
              id='modal-modal-title'
              align='center'
              variant='h5'
              component='h2'
            >
              Reset Password
            </CustomTypography>
            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <Grid container className={classes.gridClass} spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='password'
                    control={control}
                    render={({ field }) => (
                      <div className={classes.textInputContainer}>
                        <CustomTextField
                          {...field}
                          label='New Password'
                          type={password ? 'text' : 'password'}
                          fullWidth
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            field.onChange(e.target.value, clearErrors('root'));
                          }}
                        />
                        <ShowPassword
                          showPassword={password}
                          onClick={() => setPassword(!password)}
                        />
                      </div>
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please enter a new Password',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "password can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography
                    variant='body2'
                    color={'red'}
                    align='justify'
                  >
                    {errors.password?.message?.toString()}
                  </CustomTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='confirmPassword'
                    control={control}
                    render={({ field }) => (
                      <div className={classes.textInputContainer}>
                        <CustomTextField
                          {...field}
                          label='Confirm Password'
                          type={confirmPassword ? 'text' : 'password'}
                          fullWidth
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            field.onChange(e.target.value, clearErrors('root'));
                          }}
                        />
                        <ShowPassword
                          showPassword={confirmPassword}
                          onClick={() => setConfirmPassword(!confirmPassword)}
                        />
                      </div>
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please Re-enter a Password',
                      },
                      minLength: {
                        value: 6,
                        message: 'Confirm password must be 6 character',
                      },
                      maxLength: {
                        value: 20,
                        message:
                          'Confirm password must be less than 20 character',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "Confirm password can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography
                    variant='body2'
                    color={'red'}
                    align='justify'
                  >
                    {errors.confirmPassword?.message?.toString()}
                  </CustomTypography>
                </Grid>
                <CustomButton
                  type='submit'
                  fullWidth
                  color='primary'
                  className={classes.customBtnClass}
                >
                  {' '}
                  Reset Password
                </CustomButton>
              </Grid>
            </form>
            <div onClick={handlePopUp}>
              <CloseIcon
                fontSize='large'
                className={classes.closeIconClass}
                color='primary'
              />
            </div>
          </Box>
        </>
      </Modal>
    </Container>
  );
};

export default ResetPassword;
